import { ApiClient } from "./ApiClient";
import qs from "qs";
import { OfficeAttributes } from "typings";

const officesPath = "/api/v2/offices";

export const getAll = ({
  filter,
  include,
  number,
  size = 200,
  sort,
}: {
  filter?: { [key: string]: string | undefined };
  include?: string[];
  number?: number;
  size?: number;
  sort?: string;
} = {}) => {
  const params = qs.stringify(
    { sort, include, filter, page: { number, size } },
    { arrayFormat: "comma" },
  );
  return ApiClient().get(`${officesPath}?${params}`);
};

const edit = (
  officeId: string,
  attributes: {
    name?: string;
    pacerUsername?: string;
    pacerPassword?: string;
  },
  options?: {
    include: string[];
  },
) => {
  const params = qs.stringify(options, { arrayFormat: "comma" });
  return ApiClient().patch(`${officesPath}/${officeId}?${params}`, {
    data: {
      type: "offices",
      id: officeId,
      attributes,
    },
  });
};

const create = (
  attributes: OfficeAttributes,
  options?: {
    include?: string[];
  },
) => {
  const params = qs.stringify(options, { arrayFormat: "comma" });
  return ApiClient().post(`${officesPath}?${params}`, {
    data: {
      type: "offices",
      attributes,
    },
  });
};

const remove = (officeId: string) =>
  ApiClient().delete(`${officesPath}/${officeId}`);

export default {
  getAll,
  edit,
  create,
  remove,
};
